module.exports = __webpack_public_path__ + "static/media/hall-CSA.fa4067b1.svg";